export default __webpack_public_path__ + "static/media/arrow.4b3d2d93.svg";